module.exports = __webpack_public_path__ + "img/yuyin_1.220e7fe4.gif";